module.exports = __webpack_public_path__ + "img/DINplus_large.ea836e6.png";